import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VuetifyDateAdapter } from 'vuetify/lib/composables/date/adapters/vuetify.mjs'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

function clampToMonth(year, monthIndex, day) {
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate()
  return new Date(year, monthIndex, Math.min(day, daysInMonth))
}

/**
 * Native Date.setMonth overflows (e.g. Aug 31 → April becomes May 1).
 * Vuetify's month picker uses setMonth(today, monthIndex), so on the 31st
 * shorter months jump forward. Clamp the day instead.
 */
class SafeDateAdapter extends VuetifyDateAdapter {
  setMonth(date, monthIndex) {
    return clampToMonth(date.getFullYear(), monthIndex, date.getDate())
  }

  addMonths(date, amount) {
    const totalMonths = date.getFullYear() * 12 + date.getMonth() + amount
    const year = Math.floor(totalMonths / 12)
    const month = ((totalMonths % 12) + 12) % 12
    return clampToMonth(year, month, date.getDate())
  }

  setYear(date, year) {
    return clampToMonth(year, date.getMonth(), date.getDate())
  }
}

export default createVuetify({
  components,
  directives,
  date: {
    adapter: SafeDateAdapter,
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#0066CC', // rgb(0, 102, 204) - Vibrant tech blue
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
    },
  },
})

